<template>
  <a-card>
    <div slot="title">
      <div class="m-display-flex space-between">
        <div>
          <a-icon type="pic-center" />&nbsp;
          <span>PP Queue GA</span>
        </div>
        <span>Grand Total : {{ formatRupiah(grandtotalValue) }}</span>
      </div>
    </div>
    <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
      <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
        <a-input-search
          v-model="search"
          placeholder="input search text"
          class="margin-bottom"
        />
      </a-col>
    </a-row>
    <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
      <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
        <a-table
          :columns="columns"
          :dataSource="dataUrgent"
          rowKey="id_pp"
          id="urgent"
          :loading="loadingUrgent"
          size="small"
          :pagination="pagination"
          bordered
          :scroll="{ x: 100 }"
        >
          <template slot="title">
            <div class="m-display-flex space-between">
              <h4 slot="title">List PP Queue</h4>
              <div class="float-right">
                <h4 class="margin-remove">
                  Total Value check : {{ formatRupiah(total.check) }}
                </h4>
                <h4 class="margin-remove">
                  Total Value uncheck :
                  {{ formatRupiah(total.uncheck) }}
                </h4>
              </div>
            </div>
          </template>
          <span slot="no_index" slot-scope="item, records, index">{{index + 1}}</span>
          <a slot="no_pp" slot-scope="item" @click="handleLink(item.id_pp)">{{
            item.no_pp
          }}</a>
          <span slot="value" slot-scope="amount">
            <CurrencyJustified
              v-if="amount.estimated_value"
              :currencyValue="amount.currency"
              :valueNumber="amount.estimated_value"
            />
            <div v-else style="text-align: center; width: 100%">-</div>
          </span>
          <span slot="update_by" slot-scope="item">
            <a-row>
              <!-- <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
                <span
                  >GA : {{ item.tlc_priority }} /
                  {{
                    item.priority_dt
                      ? moment(
                          item.priority_dt,
                          getDateTimeStandartFormat
                        ).format(getDefaultDateFormat)
                      : "-"
                  }}
                </span>
                <a-popover title="Description">
                  <template slot="content">
                    <p>{{ item.remark_ga_pur ? item.remark_ga_pur : "-" }}</p>
                  </template>
                  <a-button icon="dash" size="small" style="float: right" />
                </a-popover>
              </a-col> -->
              <a-col :xs="{ span: 24 }" :lg="{ span: 24 }">
                <span
                  >{{ item.direktorat }} : {{ item.tlc_dana }} /
                  {{
                    item.dana_dt
                      ? moment(item.dana_dt, getDateTimeStandartFormat).format(
                          getDefaultDateFormat
                        )
                      : "-"
                  }}
                </span>
                <a-popover title="Description">
                  <template slot="content">
                    <p>{{ item.remark_keu ? item.remark_keu : "-" }}</p>
                  </template>
                  <a-button icon="dash" size="small" style="float: right" />
                </a-popover>
              </a-col>
            </a-row>
          </span>
          <span slot="dana_sts" slot-scope="item">
            <!-- <a-popconfirm
              v-if="UrGentDisable"
              title="Sure to change ?"
              @confirm="changeActionItem(item, 'urgent')"
            >
              <a-checkbox
                :default-checked="item.dana_sts === '0' ? false : true"
              />
            </a-popconfirm> -->

            <a-popconfirm
              v-if="item.dana_sts === '0'"
              title="Sure to change ?"
              @confirm="changeActionItem(item, 'urgent')"
            >
              <a-checkbox
                :default-checked="item.dana_sts === '0' ? false : true"
              />
            </a-popconfirm>
            <a-checkbox
              v-else
              :default-checked="item.dana_sts === '0' ? false : true"
              disabled
            />
          </span>
        </a-table>
      </a-col>
    </a-row>
    <a-modal v-model="modalNote" :maskClosable="false" :closable="false">
      <span slot="title"> <a-icon type="send" />&nbsp;{{ tempTitle }} </span>

      <a-form :form="formNote">
        <a-form-item label="Note">
          <a-textarea
            class="m-width-full"
            v-decorator="['remark', { rules: [{ required: true, message:'Note is required' }] }]"
          />
        </a-form-item>
      </a-form>

      <template slot="footer">
        <a-button key="back" @click="CancelData"> Cancel </a-button>
        <a-button key="submit" type="primary" @click="PostData">
          Submit
        </a-button>
      </template>
    </a-modal>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import moment from "moment";
import axios from "axios";
import _ from "lodash";

export default {
  name: "priority_ga",
  mixins: [CurrencyFormat],
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStatus",
      "getKategori",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getAllMataUang",
      "getNavigation",
      "getNavigationId",
      "getDateTimeFormat",
      "getDateTimeStandartFormat",
    ]),
    columns() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "No",
          key: "no",
          width: 30,
          align: "center",
          dataIndex: "no"
          // scopedSlots: {customRender : "no_index"}
        },
        {
          title: "No PP",
          width: 130,
          key: "no_pp",
          scopedSlots: { customRender: "no_pp" },
        },
        {
          title: "Description",
          key: "deskripsi",
          dataIndex: "deskripsi",
          width: 180,
        },

        {
          title: "Value",
          key: "value",
          width: 100,
          scopedSlots: { customRender: "value" },
        },
        {
          title: "Update By",
          key: "update_by",
          width: 130,
          scopedSlots: { customRender: "update_by" },
        },
        {
          title: "Status Dana",
          key: "dana_sts",
          width: 50,
          align: "center",
          scopedSlots: { customRender: "dana_sts" },
        },
      ];
      return kolom;
    },
    UrGentDisable() {
      if (this.dataUrgent.some((v) => v.dana_sts === "0")) {
        return true;
      } else {
        if (this.dataUrgent.every((v) => v.dana_sts === "1")) {
          if (this.dataMedium.some((v) => v.dana_sts === "1")) {
            return false;
          }
          return true;
        } else {
          return false;
        }
      }
    },
    grandtotalValue() {
      return (
        this.totalData.total_belum_urgent
      );
    },
  },
  data() {
    return {
      pagination: {
        onChange: (page) => {
          // console.log(page);
        },
        pageSize: 15,
        size: "small",
      },
      search: "",
      dataUrgent: [],
      dataUrgenttemp: [],
      loadingNotSet: false,
      loadingNormal: false,
      loadingMedium: false,
      loadingUrgent: false,
      modalNote: false,
      tempDataPost: null,
      tempTablePost: null,
      tempTitle: null,
      totalData: {
        total_belum_urgent: 0,
      },
      total: {
        uncheck : 0,
        check: 0
      },
    };
  },
  mounted() {
    this.fetchData();
  },
  beforeCreate() {
    this.formNote = this.$form.createForm(this);
  },
  watch:{
    search(){
      if(this.search!=""){
        this.dataUrgent = _.filter(this.dataUrgenttemp,
          (element) =>
            (element.no_pp && element.no_pp .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0) ||
            (element.deskripsi && element.deskripsi .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0)
        );
      }else{
        this.dataUrgent = this.dataUrgenttemp;
      }
    }
  },
  methods: {
    moment,
    fetchData() {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: this.$serviceUrl + "priority/list_ga_pur",
          params: {
            sub_menu: "ga",
            tlc: this.getAuth.username,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.dataUrgent = response.data.list_data;
            this.dataUrgent.forEach((element,index) => {
              this.dataUrgent[index].seq_priority = index+1;
              this.dataUrgent[index].no = index + 1
            });
            this.totalData.total_belum_urgent = response.data.grand_total;
            this.total = {
              check: response.data.check_total,
              uncheck: response.data.uncheck_total
            }
            this.dataUrgenttemp = this.dataUrgent;
            resolve(response);
          })
          .catch((err) => {
            if (!err.response) {
              this.displayMessage("error-connection-refused");
            } else {
              this.loading = false;
              this.displayMessage("empty-db");
            }

            reject(err);
          });
      });
    },
    changeActionItem(e, table) {
      if (e.dana_sts === "1") {
        if (table === "notset") {
          this.loadingNotSet = true;
        } else if (table === "urgent") {
          this.loadingUrgent = true;
        } else if (table === "normal") {
          this.loadingNormal = true;
        } else if (table === "medium") {
          this.loadingMedium = true;
        }

        axios({
          method: "post",
          url: this.$serviceUrl + "priority/dana",
          processData: false,
          data: {
            id_pp: e.id_pp,
            tlc: this.getAuth.username,
            dana_sts: "0",
            remark: null,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.dataNotSet = [];
            this.dataUrgent = [];
            this.dataNormal = [];
            this.dataMedium = [];
            this.fetchData().then(() => {
              if (table === "notset") {
                this.loadingNotSet = false;
              } else if (table === "urgent") {
                this.loadingUrgent = false;
              } else if (table === "normal") {
                this.loadingNormal = false;
              } else if (table === "medium") {
                this.loadingMedium = false;
              }
            });
          })
          .catch((err) => {
            console.log("error : " + err);
          });
      } else {
        this.modalNote = true;
      }

      this.tempDataPost = e;
      this.tempTablePost = table;
      this.tempTitle = e.no_pp;
    },
    CancelData() {
      this.tempTablePost = null;
      this.tempDataPost = null;
      this.modalNote = false;
    },
    PostData() {
      this.formNote.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        if (this.tempTablePost === "notset") {
          this.loadingNotSet = true;
        } else if (this.tempTablePost === "urgent") {
          this.loadingUrgent = true;
        } else if (this.tempTablePost === "normal") {
          this.loadingNormal = true;
        } else if (this.tempTablePost === "medium") {
          this.loadingMedium = true;
        }

        let status = this.tempDataPost.dana_sts == "0" ? "1" : "0";

        axios({
          method: "post",
          url: this.$serviceUrl + "priority/dana",
          processData: false,
          data: {
            id_pp: this.tempDataPost.id_pp,
            tlc: this.getAuth.username,
            dana_sts: status,
            remark: values.remark,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.dataNotSet = [];
            this.dataUrgent = [];
            this.dataNormal = [];
            this.dataMedium = [];
            this.fetchData().then(() => {
              if (this.tempTablePost === "notset") {
                this.loadingNotSet = false;
              } else if (this.tempTablePost === "urgent") {
                this.loadingUrgent = false;
              } else if (this.tempTablePost === "normal") {
                this.loadingNormal = false;
              } else if (this.tempTablePost === "medium") {
                this.loadingMedium = false;
              }
              this.tempTablePost = null;
              this.tempDataPost = null;
              this.modalNote = false;
              this.formNote.resetFields();
            });
          })
          .catch((err) => {
            console.log("error : " + err);
          });
      });
    },
    handleLink(id_pp) {
      const route = this.$router.resolve({
        name: "manifestPp",
        params: { id: id_pp },
      });
      window.open(route.href, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.float-right {
  float: right;
  text-align: right;
}
</style>